import { Field as ChakraField } from '@chakra-ui/react';
import type { ConditionalValue } from '@chakra-ui/react';
import type { CssProperties } from 'node_modules/@chakra-ui/react/dist/types/styled-system/css.types';
import type { UtilityValues } from 'node_modules/@chakra-ui/react/dist/types/styled-system/generated/prop-types.gen';
import type { AnyString, CssVars } from 'node_modules/@chakra-ui/react/dist/types/styled-system/generated/system.gen';
import * as React from 'react';

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  errorText?: React.ReactNode;
  optionalText?: React.ReactNode;
  fontSize?: ConditionalValue<UtilityValues['fontSize'] | CssVars | CssProperties['fontSize'] | AnyString>;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const { label, children, helperText, errorText, optionalText, fontSize = 'xs', ...rest } = props;
  return (
    <ChakraField.Root ref={ref} {...rest}>
      {label && (
        <ChakraField.Label fontSize={fontSize}>
          {label}
          <ChakraField.RequiredIndicator fallback={optionalText} />
        </ChakraField.Label>
      )}
      {children}
      {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  );
});
